import './about.css';
const About=()=>{
    const design=(
        <>
           <div className="container about-bottom-box" id="about">
                    <div className="row">
                        <h2>About</h2>
                        <div className="col-md-6">
                        <br />
                            <img src="./img/code.webp" className='w-100 animated'  alt="" />
                        </div>
                        <div className="col-md-6">
                        <br />
                            <h1>React & Node Js Developer</h1>
                            <p>Excellent capability to explore, learn & understand newer business domains & technology.</p>
                            <div className="row icon-box">
                                <div className="col-md-6">
                                    <ul className='list-group'>
                                    <li class="list-group-item bg-transparent border-0"> <i class="fa-solid fa-chevron-right px-1"></i>
                                     <strong>Birthday :</strong> 01-03-2001
                                    </li>
                                    <li class="list-group-item bg-transparent border-0"><i class="fa-solid fa-chevron-right px-1"></i>
                                       <strong>Website:</strong> <strong className='text-decoration-underline'>akhzar.netlify.app</strong>
                                    </li>
                                    <li class="list-group-item bg-transparent border-0"><i class="fa-solid fa-chevron-right px-1"></i>
                                        <strong>Phone :</strong> +91 7860754122
                                    </li>
                                    <li class="list-group-item bg-transparent border-0"><i class="fa-solid fa-chevron-right px-1"></i>
                                        <strong>City :</strong> Azamgarh U.P
                                    </li>
                                    </ul>
                                </div>
                                <div className="col-md-6">
                                    <ul className='list-group'>
                                    <li class="list-group-item bg-transparent border-0"> <i class="fa-solid fa-chevron-right px-1"></i>
                                     <strong>Age :</strong> 22
                                    </li>
                                    <li class="list-group-item bg-transparent border-0"><i class="fa-solid fa-chevron-right px-1"></i>
                                        <strong>Degree :</strong> Bachloer of Technology
                                    </li>
                                    <li class="list-group-item bg-transparent border-0"><i class="fa-solid fa-chevron-right px-1"></i>
                                        <strong>Email :</strong> akhzarazmi@gmail.com
                                    </li>
                                    <li class="list-group-item bg-transparent border-0"><i class="fa-solid fa-chevron-right px-1"></i>
                                        <strong>Freelancer :</strong> Availabel
                                    </li>
                                    </ul>
                                <br />
                                </div>
                                <h6>Quest to work & learn in a real professional world that enables me to cope with the emerging as well as latest technology and scope the widening the spectrum of my knowledge.</h6>
                            </div>
                        </div>
                    </div>
                </div>
        </>
    )
    return design;
}
export default About;